/**
 * Configuración de marketing/tracking mostrada en el sitio público.
 * Editable desde Preferencias → Config CRM (superadmin) y almacenada
 * en `crm_configuracion`, junto al resto de la configuración del CRM.
 */
export interface MarketingConfig {
  /** Conversion ID de Google Ads (formato AW-XXXXXXXXX), o null si no está configurado. */
  googleAdsConversionId: string | null;
  /** Conversion label de la acción de conversión de Google Ads, o null si no está configurado. */
  googleAdsConversionLabel: string | null;
  /** Conversion label de la acción de conversión de Google Ads para clics a
   * WhatsApp (misma cuenta, acción independiente), o null si no está configurado. */
  googleAdsWhatsappConversionLabel: string | null;
  /** Si Google Tag Gateway (Cloudflare) ya está activo en la zona: cuando lo está,
   * el preconnect/dns-prefetch directo a googletagmanager.com/google-analytics.com
   * es redundante porque esas peticiones se sirven desde el propio dominio. */
  googleTagGatewayEnabled: boolean;
}

/** Sin configuración: la feature queda apagada, no se dispara ningún evento. */
export const DEFAULT_MARKETING_CONFIG: MarketingConfig = {
  googleAdsConversionId: null,
  googleAdsConversionLabel: null,
  googleAdsWhatsappConversionLabel: null,
  googleTagGatewayEnabled: true,
};
